<template>
  <div id="welcome-kit-choice-form">
    <header v-if="!hideTitle" class="panel__header mt-2">
      <div class="row">
        <div class="col-8">
          <h2 class="panel__title">Escolha o seu welcome kit!</h2>
        </div>
      </div>
    </header>

    <div id="welcome-kit-form" class="row mt-4">
      <div class="col-12">
        <div class="row justify-content-center" v-if="selected != null && plano.kits[0] != null">
          <div
            v-for="kit in plano.kits" 
            :key="kit.id"
            :class="{
              'col-md-4': true,
              'col-12': true,
              'justify-content-center': true,
              'align-items-center': true,
              'welcome-kit-item': true,
              'active': kit.id === selected.id
            }"
            @click="select(kit)"
          >
            <div class="card p-4">
              <span v-if="kit.id === selected.id" class="checkmark">
                <i class="fa-duotone fa-badge-check"></i>
              </span>
              <img class="welcome-kit-image" v-if="kit.image" :src="kit.image" :alt="kit.title">
              <h4 class="welcome-kit-title" v-html="kit.title"></h4>
              <small class="welcome-kit-value"><i>{{(kit.value / 100) | currency}} por cota</i></small>
              <div class="welcome-kit-description" v-html="kit.description"></div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center my-4" v-if="selected != null && selected.key != 'Digital' && !hideDelivery">
          <div class="col-12 col-md-6 text-center">
            <h4 class="delivery-title">Escolha o local de entrega</h4>            
            <select 
              v-model="selectedDelivery" 
              class="form-select mx-auto"
            >
              <option :value="null" disabled>Selecione uma opção de entrega...</option>
              <option 
                v-for="option in deliveryOptions" 
                :key="option.value" 
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert
          variant="danger"
          :show="error.show"
          v-model="error.show"
        >
          <div>{{ error.message }}</div>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      selected: null,
      selectedDelivery: null,
      error: {
        show: false,
        message: ''
      }
    }
  },
  mounted() {
    console.log(this.plano.kits[0])
    this.selected = this.plano.kits[0]
    if (this.deliveryOptions.length > 0) {
      this.selectedDelivery = this.deliveryOptions[0].value
    }
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    hideTitle: {
      required: false,
      type: Boolean,
      default: false,
    },
    hideDelivery: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  computed: {
    deliveryOptions() {
      if (!this.plano) {
        return [];
      }

      const options = [];

      if (this.plano.entrega_residencia === 'Y') {
        options.push({ value: 'Residencia', label: 'Residência' });
      }

      if (this.plano.entrega_clube === 'Y') {
        options.push({ value: 'Clube', label: 'Clube' });
      }

      return options;
    }
  },
  methods: {
    submit() {
      if (!this.validate()) {
        this.error.show = true
        this.error.message = "Você precisa escolher uma opção para prosseguir"
        return false
      } else {
        this.user.kit = this.selected
        return true
      }
    },
    validate() {
      return this.selected.id != 0 && this.selectedDelivery.length > 0
    },
    select(kit) {
      this.selected = kit
      this.$emit("change", kit)
    }
  },
})
</script>